import debounce from 'lodash/debounce';

export function asyncDebounce(func: any, wait: any): (...args: any[]) => Promise<unknown> {
	const debounced = debounce(async (resolve: any, reject: any, bindSelf: any, args: any) => {
		try {
			const result: any = await func.bind(bindSelf)(...args);
			resolve(result);
		} catch (error) {
			reject(error);
		}
	}, wait);
	function returnFunc(...args: any[]) {
		return new Promise((resolve, reject) => {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			// eslint-disable-next-line no-invalid-this
			debounced(resolve, reject, this, args);
		});
	}

	return returnFunc;
}
